module.exports = __webpack_public_path__ + "img/uk_success_2.d0a62949.png";